<template>
  <div class="main">
    <div class="logo"></div>
  <div class="content resetpwd">
    <div class="title font-size24 color-msg">重置密码</div>
    <div class="font-size14 color-msg cue">请重设您的帐号密码</div>
    <div class="ipt-box font-size14">
      <div class="account-ipt">
        <input class="input" placeholder="新密码" type="password" v-on:focus="pwdFocus" v-on:blur="pwdBlur" v-model="pwd"/>
        <div class="msg-box" v-show="pwdData.errMsgShow&&!isMobile">
          <div class="icon"></div>
          <div class="text color-msg font-size12">{{pwdData.errMsg}}</div>
        </div>
      </div>
      <div class="account-ipt">
        <input class="input" placeholder="确认新密码" type="password" v-on:focus="repwdFocus" v-on:blur="repwdBlur" v-model="repwd"/>
        <div class="msg-box" v-show="repwdData.errMsgShow&&!isMobile">
          <div class="icon"></div>
          <div class="text color-msg font-size12">{{repwdData.errMsg}}</div>
        </div>
      </div>
      <div class="font-size14 color-msg bottom-cue">密码长度6-20位，数字、字母、_至少包含两种</div>
      <div class="account-btn" @click="resetPwd" v-show=" submitBtnState==CONF.submitBtnState.enable">确&nbsp;定</div>
      <div class="account-btn disable" v-show=" submitBtnState==CONF.submitBtnState.disable">确&nbsp;定</div>
    </div>
  </div>
  </div>
</template>
<style scoped>
  .resetpwd .account-btn{
    margin-top: 0;
  }
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default {
    data () {
      return {
        CONF: CONF,
        verifyCode: '',
        pwd: '',
        repwd: '',
        pwdData: {errMsgShow: false, errMsg: ''},
        repwdData: {errMsgShow: false, errMsg: ''},
        submitBtnState: CONF.submitBtnState.disable,
        callback: '',
        isMobile: ''
      }
    },
    watch: {
      pwd (newValue) {
        if (newValue.length > 0) {
          this.submitBtnState = CONF.submitBtnState.enable
        } else {
          this.submitBtnState = CONF.submitBtnState.disable
        }
      },
      repwd (newValue) {
        if (newValue.length > 0) {
          this.submitBtnState = CONF.submitBtnState.enable
        } else {
          this.submitBtnState = CONF.submitBtnState.disable
        }
      }
    },
    created () {
      this.isMobile = server.isMobile()
      if (this.$route.params.verifyCode === undefined || this.$route.params.account === undefined) {
        this.$router.push(CONF.urlList.ResetGetAccount.path + window.location.search)
      }
      if (this.$route.query.callback) {
        this.callback = this.$route.query.callback
      }
      this.account = this.$route.params.account
      this.verifyCode = this.$route.params.verifyCode
    },
    methods: {
      resetPwd () {
        if (!CONF.reg.pwd.test(this.pwd) || this.repwd !== this.pwd) return
        let that = this
        let data = {verifyCode: this.verifyCode, password: this.pwd}
        this.submitBtnState = CONF.submitBtnState.disable
        server.appServices(this, CONF.APIList.resetPwd, data).then(res => {
          if (res.status === CONF.errCode.success.code) {
            let nextRoute = CONF.urlList.ResetpwdSuccess
            nextRoute.query = {}
            if (this.$route.query.callback) {
              nextRoute.query.callback = this.$route.query.callback
            }
            if (this.$route.query.connectid) {
              nextRoute.query.connectid = this.$route.query.connectid
            }
            nextRoute.params = {account: that.account}
            this.$router.push(nextRoute)
          } else {
            this.submitBtnState = CONF.submitBtnState.enable
            this.showErrMsg(CONF.errCode['code' + res.status].msg, false)
          }
        })
      },
      pwdFocus () {
        this.pwdData.errMsgShow = false
      },
      pwdBlur () {
        if (this.pwd.length === 0) {
          this.showErrMsg(CONF.errorMsg.empty.pwd)
          return
        }
        if (!CONF.reg.pwd.test(this.pwd)) {
          this.showErrMsg(CONF.errorMsg.format.pwd, false)
        }
      },
      repwdFocus () {
        this.repwdData.errMsgShow = false
      },
      repwdBlur () {
        if (this.repwd !== this.pwd) {
          this.showErrMsg(CONF.errorMsg.format.repwd, true)
        }
      },
      showErrMsg (msg, isRepwd) {
        if (this.isMobile) {
          this.$toast({toastMsg: msg})
        }
        if (isRepwd) {
          this.repwdData.errMsgShow = true
          this.repwdData.errMsg = msg
        } else {
          this.pwdData.errMsgShow = true
          this.pwdData.errMsg = msg
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResetSetPwd.vue?85a66e1a